import Fetch from 'ahooks/es/useRequest/src/Fetch';
import { message, notification } from 'antd';

import { useI18nContext } from '@/i18n/I18n';
import { UserInfo } from '@/services/types/common';
import { IBaseResponse, IResult } from '@/services/types/common';
import { isUnAuthPage } from '@/utils/loginAuth';
import redirectUrlMap from '@/utils/redirectUrlMap';
import isApp from '@/utils/ua';
interface IErrorType {
  ret_code: number;
  ret_msg: string;
  ext_info: string;
  ext_code: string | number;
  message?: string;
}
export function useErrorMsg(
  mutate?: Fetch<IBaseResponse<IResult>, []>['mutate'],
) {
  const [$t] = useI18nContext();
  const noticeError = (title: string, error: IErrorType) => {
    const desc =
      [30027, 30028, 30029, 30030, 30074, 30075].indexOf(error.ret_code) >= 0
        ? plErrMsg(error)
        : errorCommon(error);
    if (desc) {
      notification.open({
        message: title,
        description: desc,
      });
    }
  };

  const msgError = (error: IErrorType) => {
    const content =
      [30027, 30028, 30029, 30030, 30074, 30075].indexOf(error.ret_code) >= 0
        ? plErrMsg(error)
        : errorCommon(error);
    if (content) {
      message.error(content);
    }
  };

  const errorCommon = (error: IErrorType) => {
    if (!isApp()) {
      if (error.ret_code === 10007) {
        // 用户ID非零为已登陆，零为未登陆。
        mutate?.((profile) => {
          if (profile?.result) profile.result = { id: 0 } as UserInfo;
          return profile;
        });
        // 跳转
        if (!isUnAuthPage()) {
          redirectUrlMap.redirectLogin();
        }
        return null;
      }
    }

    const { ret_code, ret_msg } = error;
    let desc;
    if (ret_code) {
      // 错误码为 -1 时，提示后端返回的信息
      if (
        ret_code === -1 ||
        ret_code === 31018 ||
        ret_code === 20064 ||
        ret_code === 20065
      ) {
        desc = `${ret_code}: ${ret_msg}`;
      } else {
        const msg = $t(`${ret_code}`, { ns: 'inverse-error-code' }); // 国际化
        if (msg !== `${ret_code}`) {
          desc = `${ret_code}: ${msg}`;
        } else if (ret_code === 40029) {
          desc = `${ret_code}: This account has been terminated.`;
        } else {
          desc = `${ret_code}: ${ret_msg || 'request error'}`;
        }
      }
    } else {
      desc = ret_msg || error.message;
    }
    return desc;
  };

  const plErrMsg = (error: IErrorType) => {
    const { ret_code, ret_msg } = error;
    const index = ret_msg.indexOf('??');
    if (index < 0) return msgError(error);
    const triggerObj: any = {
      LastPrice: $t('Market Price'),
      IndexPrice: $t('Index Price'),
      MarkPrice: $t('Mark Price'),
    };
    const triggerIndex: string = ret_msg.slice(index + 2);
    const triggerBy = triggerObj[triggerIndex];
    return $t(`${ret_code}:triggerBy`.replace('triggerBy', triggerBy), {
      ns: 'inverse-error-code',
    });
  };

  return {
    noticeError,
    msgError,
    errorCommon,
    plErrMsg,
  };
}
